// components/ContactPage/ContactPageSection1.jsx
import React, { useState } from 'react';
import Navbar1 from '../Navbar/Navbar1/Navbar1';
import Footer from '../Footer/Footer';
import contactImage from '../../assets/Contact.jpg';
import './Contact.css';


const API_URL = process.env.REACT_APP_BACKEND_URI || 'http://localhost:6111';
console.log("API_URL:", API_URL);

const Contact = ({ onNavigate }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    termsAccepted: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (!formData.termsAccepted) {
  //     alert("Please accept the terms to continue.");
  //     return;
  //   }
  //   // Handle form submission (e.g., send to backend)
  //   console.log('Form submitted:', formData);
  // };


  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const response = await fetch(`${API_URL}/api/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formData.message,
        }),
      });
  
      const data = await response.json();
  
      if (response.ok) {
        alert("Message sent successfully!");
  
        setFormData({
          name: "",
          email: "",
          message: "",
          termsAccepted: false,
        });
  
        console.log(data);
      } else {
        alert(data.message || data.error || "Failed to send message");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Server error. Please try again.");
    }
  };

  return (
    <>
      <Navbar1 onNavigate={onNavigate} />

      {/* Section 1: Hero */}
      <section className="contact-hero-section">
        <h1 className="contact-hero-title">
          Transforming Data into <br /> Actionable Insights
        </h1>
        <p className="contact-hero-subtitle">
          We're here to provide answers and support your journey towards smarter maritime solutions.
        </p>
      </section>

      {/* Section 2: Form + Image */}
      <section className="contact-form-section">
        <div className="contact-form-container">
          <div className="contact-left">
            <h4 className="contact-connect-label">Connect</h4>
            <h2 className="contact-title">Get in Touch</h2>
            <p className="contact-subtitle">We'd love to hear from you!</p>

            <form onSubmit={handleSubmit}>
              <label>Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <label>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />

              <label>Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows={6}
                placeholder="Type your message..."
                required
              />

              {/* <div className="checkbox-row">
                <input
                  type="checkbox"
                  name="termsAccepted"
                  checked={formData.termsAccepted}
                  onChange={handleChange}
                />
                <span>I accept the Terms</span>
              </div> */}

              <button type="submit" className="send-button">SEND</button>
            </form>
          </div>

          <div className="contact-right">
            <img src={contactImage} alt="Contact Visual" className="contact-image" />
          </div>
        </div>
      </section>

      <Footer onNavigate={onNavigate} />
    </>
  );
};

export default Contact;
